/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  CreatePouchBodyBody,
  CreatePouchResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Suspend Pouch in Preparation for a pouchID
 */
export const pouchPreparationSuspend = (
  pouchID: string,
  createPouchBodyBody: CreatePouchBodyBody,
) => {
  return customInstance<CreatePouchResponseResponse>({
    url: `/bm-pouch-management/v1/preparation/suspend/${pouchID}`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: createPouchBodyBody,
  });
};

export const getPouchPreparationSuspendMutationOptions = <
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pouchPreparationSuspend>>,
    TError,
    { pouchID: string; data: CreatePouchBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pouchPreparationSuspend>>,
  TError,
  { pouchID: string; data: CreatePouchBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pouchPreparationSuspend>>,
    { pouchID: string; data: CreatePouchBodyBody }
  > = (props) => {
    const { pouchID, data } = props ?? {};

    return pouchPreparationSuspend(pouchID, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PouchPreparationSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof pouchPreparationSuspend>>
>;
export type PouchPreparationSuspendMutationBody = CreatePouchBodyBody;
export type PouchPreparationSuspendMutationError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Suspend Pouch in Preparation for a pouchID
 */
export const usePouchPreparationSuspend = <
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pouchPreparationSuspend>>,
    TError,
    { pouchID: string; data: CreatePouchBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getPouchPreparationSuspendMutationOptions(options);

  return useMutation(mutationOptions);
};
